var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_9631)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8931 11.2755L12.2404 9.22216C12.1123 9.12329 11.9526 9.07451 11.7911 9.08494C11.6296 9.09537 11.4774 9.1643 11.3631 9.27882L9.9551 10.6875C9.85023 10.7934 9.71267 10.8609 9.5647 10.8789C9.41673 10.8969 9.26701 10.8645 9.13977 10.7868C8.68643 10.5088 7.92777 9.97015 6.97843 9.02015C6.0291 8.07149 5.49043 7.31216 5.21243 6.85949C5.13468 6.73235 5.10224 6.58264 5.12039 6.43472C5.13855 6.2868 5.20624 6.14938 5.31243 6.04482L6.72043 4.63616C6.83512 4.52189 6.9041 4.36965 6.91442 4.20808C6.92473 4.04652 6.87566 3.88675 6.77643 3.75882L4.72377 1.10549C4.2571 0.503489 3.3771 0.408155 2.80377 0.911489C2.04843 1.57416 1.1411 2.56682 0.8771 3.68082C0.3991 5.68749 1.15443 8.20549 4.47443 11.5255C7.79443 14.8448 10.3124 15.6008 12.3184 15.1235C13.4324 14.8582 14.4258 13.9502 15.0884 13.1955C15.5911 12.6222 15.4958 11.7422 14.8931 11.2755Z",
    fill: "#4A5056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_9631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e9c9e93ad8f1c870db212a740eb171a2.svg";
export { ForwardRef as ReactComponent };